import { store } from '../Redux/store'

import { getAuthAppURL, parseLocalStorageJwt } from "../utility/auth";
import { urlEncode } from '../utility/http';
import routeListen from "./routeListen";
import tokenStorageService from "./TokenStorageService";

function getToken() {
  return tokenStorageService.getItem("token")
}

function getOrgShortName() {
  const token = getToken();
  let parsedJwt: any;
  let orgShortName: string = "";

  if (token) {
    parsedJwt = parseLocalStorageJwt(token);
    orgShortName = parsedJwt?.org_short_name;
  }
  
  if(!orgShortName && tokenStorageService.getItem('orgShortName')) {
    orgShortName = tokenStorageService.getItem('orgShortName')  || ''
  }

  if(!orgShortName && routeListen.shortName()) {
    orgShortName = routeListen.shortName()
  }


  return orgShortName;
}

function logOut(params?: { noRedirect?: boolean, keepOrgName?: boolean }) {
  // clear local storage
  tokenStorageService.removeItem("userStatus");
  tokenStorageService.removeItem("token");
  tokenStorageService.removeItem("userName");
  tokenStorageService.removeItem("userId");
  
  //removing OrgShortname unless stated otherwise
  if (!params?.keepOrgName) {
    tokenStorageService.removeItem("orgShortName");
  }

  // Redirect
  if (!params?.noRedirect) {
    window.location.replace("#/organisation");
  }
}

export { getToken, getOrgShortName, logOut };
